
import { createContext } from 'react';
import { SimulationConfig } from '@/types';

export const SettingsSearchContext = createContext<string>('');
export const ConfigContext = createContext<SimulationConfig | null>(null);
